<template>
  <div>
    <el-dialog v-loading="loading" :title="type == 'create' || type == 'anewcreate' ? '提交外部追差申请' : '查看售后详情'"
      :visible.sync="visible" :close-on-click-modal="false" width="900px">
      <div class="box">
        <el-row>
          <el-col :span="13">
            <div class="title">订单信息</div>

            <div class="info-item">
              <span class="mr-30">{{ info.phoneName }}</span>
              <span>IMEI：{{ info.imei }}</span>
              <el-link type="primary" :underline="false" class="ml-10"
                @click="$refs['functionDia'].open(row)">查看功能情况</el-link>
            </div>
            <div class="info-item">
              <span class="mr-30">回收商实报价：{{ info.quotePrice }} </span>
              <span>外部成交价：{{ info.chxPrice }}</span>
            </div>
          </el-col>

          <el-col :span="24" style="margin-top:15px">
            <div class="title">平台追差内容</div>
            <div class="info-item">申请回收商：{{ info.applyMerchantName }}</div>
            <div class="info-item">
              <span class="mr-30">申请金额：{{ info.arguePrice }}元 </span>
              <span class="mr-30">初审通过金额：{{ info.auditPrice }}元</span>
              <span class="mr-30">复核打款金额：{{ info.rePayPrice || '--' }}元</span>
            </div>
          </el-col>
        </el-row>
      </div>
      <div style="display: flex;">
        <div class="button_top" v-if="type == 'detail'">
          <div class="radiobtn">
            <div class="faultBtn">
              <div v-bind:class="clickShow === '01' ? 'active' : 'none'" @click="clickChange('01')">
                售后申请详情
              </div>
              <div v-bind:class="clickShow === '02' ? 'active' : 'none'" @click="clickChange('02')">
                售后审核详情
              </div>
            </div>
          </div>
        </div>
        <div v-if="type == 'detail'" style="height: 35px; width: 90px;  border-radius: 20px 20px 20px 0; 
          border: 1px solid red;display: flex;justify-content: center;align-items: center;
           color: red; margin-left: 10px;">
          已发起{{ formData.applyNum }}次
        </div>
      </div>



      <div class="box gray">
        <div style="display: flex;margin-bottom: 10px;align-items: center;">
          <div class="title">外部售后提交信息</div>
          <div v-if="type != 'detail'" style="height: 30px; width: 90px;  border-radius: 20px; background-color: #FEF4EC;
           display: flex;justify-content: center;align-items: center;
           color: #FF710C; margin-left: 10px; font-weight: 600;">
            {{ formData.applyNum || formData.applyNum != 0 ? `已发起${formData.applyNum}次` : '暂未发起' }}
          </div>
        </div>

        <el-form v-show="clickShow == '01'" ref="formRef" :model="formData" :rules="formRule"
          :disabled="type == 'detail'">
          <!-- <el-form-item v-if="type != 'detail'" label="追差金额：" prop="arguePrice">
            <el-input v-model="formData.arguePrice" style="width:100px" />
            元
          </el-form-item> -->
          <el-form-item label="追差金额：" prop="arguePriceChx">
            <el-input v-model="formData.arguePriceChx" style="width:100px" />
          </el-form-item>

          <el-form-item label="选择追差项:" prop="checkList">
            <el-button type="primary" size="small" @click="catalogShow = true" v-if="type != 'detail'">+追差项</el-button>
            <div
              style="background-color: #fff; min-height: 60px; width: 100%;padding: 0 5px; display: flex; align-items: center;">
              <div v-if="checkList[0]">
                <el-tag style="margin: 5px;" v-for="tag in checkList" :key="tag" :closable="type != 'detail'"
                  type="danger" @close="handleTagClose(tag)">
                  {{ tag }}
                </el-tag>
              </div>
              <span v-else style="color: gray;">请添加追差项</span>
            </div>
          </el-form-item>
          <el-form-item label="追责原因：" prop="argueNote">
            <el-input v-model="formData.argueNote" type="textarea" :rows="3" />
          </el-form-item>
          <div>
            <div>追差凭证：</div>
            <div style="padding: 15px;">
              <div style="margin-bottom: 5px;">追差视频<span :style="{ color: videoMust ? 'red' : '' }">（{{ videoMust ?
                '该渠道必传' : '非必传' }}）</span></div>
              <!-- <UploadImgOrVideo :accept="'.mp4'" v-model="videos" ref="imagesRef" /> -->
              <videoScreenshot :videos="videos" @getServerVideoUrls="getServerVideoUrls"
                @getServerImageUrl="getServerImageUrl">
              </videoScreenshot>

            </div>
            <div style="padding: 15px;">
              <div style="margin-bottom: 5px;">追差照片<span :style="{ color: imageMust ? 'red' : '' }">（{{ imageMust ?
                '该渠道必传' : '非必传' }}）</span></div>
              <PasteUploadDia @confirm="(v) => formData.images.push(v)">
                <template slot-scope="scope">
                  <div style="display: flex;width: 100%;overflow-x: scroll;">
                    <div v-for="(item, index) in formData.images" :key="item" style="display: flex;">
                      <i class="el-icon-circle-close" style="margin: 0 10px;"
                        @click="formData.images.splice(index, 1)" />
                      <el-image style="height: 130px;width: 130px;margin-right: 10px;" :src="item"
                        :preview-src-list="[item]" />
                    </div>
                    <div class="upload_img"
                      style="height: 130px;width: 130px;display: flex;justify-content: center;align-items: center;flex-shrink: 0;"
                      v-if="formData.images" @click="scope.open()">
                      <i class="el-icon-plus"></i>
                    </div>
                  </div>
                </template>

              </PasteUploadDia>

            </div>
          </div>

        </el-form>
        <div v-show="clickShow == '02'" class="box gray" disabled>
          <el-form :model="formData" :rules="examineRules">
            <el-form-item label="审核状态：">
              <span style="color: #0981ff;">
                {{ optionsFilter(formData.chxState, chxStateOptions) }}
              </span>
            </el-form-item>
            <el-form-item label="追差金额：">
              <span style="color: #0981ff;">
                {{ formData.amount ? formData.amount + "元" : '--' }}
              </span>
            </el-form-item>
            <el-form-item label="实际追差类型：">
              <span style="color: #0981ff;">
                {{ formData.itemsString }}
              </span>
            </el-form-item>
            <el-form-item label="审核差备注：">
              <span style="color: #0981ff;">
                {{ formData.auditNote ? formData.auditNote : '--' }}
              </span>
            </el-form-item>
            <el-form-item label="审核补充凭证：">
              <UploadImgOrVideo :accept="'.png,.jpg'" v-model="formData.voucherActualImages"
                ref="voucherActualImagesRef" />
            </el-form-item>
          </el-form>

        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close()">取消</el-button>
        <el-button v-if="type !== 'detail'" type="primary" @click.native="confirm">确定提交</el-button>
      </span>
    </el-dialog>
    <el-dialog title="选择追差项（可多选）" :visible.sync="catalogShow" :close-on-click-modal="false" width="360px"
      @closed="catalogShow = false">
      <el-input @blur="blurInput()" style="width: 160px;margin:  15px 0;" v-model="catalogInput" placeholder="请输入名称查询"
        suffix-icon="el-icon-search"></el-input>
      <div style="height: 300px;overflow-y: scroll;">
        <el-checkbox-group v-model="checkList" style="display: flex;flex-direction: column; gap: 8px;">
          <el-checkbox v-for="(item, index) of catalogList" :key="index" :label="item.name"></el-checkbox>
        </el-checkbox-group>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click.native="catalogShow = false">取消</el-button>
        <el-button type="primary" @click.native="catalogShow = false">确定</el-button>
      </span>
    </el-dialog>
    <FunctionDia ref="functionDia" />
  </div>
</template>

<script>
import { http } from "@/utils/request/caiHuoXiaReview"
import PasteUploadDia from '../../componets/PasteUploadDia.vue';
import UploadImgOrVideo from './UploadImgOrVideo.vue';
import videoScreenshot from './videoScreenshot.vue';
import FunctionDia from './FunctionDia.vue';
import {
  chxStateOptions
} from "../initState";
export default {
  components: { UploadImgOrVideo, FunctionDia, videoScreenshot, PasteUploadDia },
  name: "ReviewApplyDia",
  data() {

    // const arguePriceVaild = (rule, value, callback) => {
    //   const number = Number(value)
    //   if (number > this.info.chxPrice) callback(new Error('不得高于外部成交金额'))
    //   callback()
    // }
    return {
      chxStateOptions,
      visible: false,
      row: {},
      info: {},
      loading: false,
      type: 'create', // create detail
      formData: {
        arguePrice: '',
        arguePriceChx: '',
        argueNote: '',
        images: [],
      },
      formRule: {
        // arguePrice: [
        //   { required: true, message: '请输入追差金额', trigger: 'change' },
        //   // { validator: arguePriceVaild, trigger: 'change' }
        // ],
        arguePriceChx: [
          { required: true, message: '请输入追差金额', trigger: 'change' },
          // { validator: arguePriceVaild, trigger: 'change' }
        ],
        // checkList: [{ required: true, message: '请选择追差项', trigger: 'change' }],
        argueNote: [{ required: true, message: '请输入追责原因', trigger: 'change' }],
        images: [{ required: true, message: '请上传图片', trigger: 'change' }],
      },
      clickShow: '01',
      catalogShow: false,
      catalogInput: '',
      chxChannelCode: '',
      catalogAllList: [],
      catalogList: [],
      checkList: [],
      examineForm: {},
      examineRules: {
        name: [
          { required: true, message: '请输入活动名称', trigger: 'blur' },
          { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
      },
      videos: [],
      videoMust: false,
      imageMust: false,
    };
  },
  methods: {
    getServerVideoUrls(data) {
      this.videos = data
    },
    getServerImageUrl(data) {
      this.formData.images = [...this.formData.images, data]

    },
    open(row, type = 'create') {
      const { outType, orderNo } = row
      http.getFlagByOutType({
        outType, orderNo
      }).then(res => {
        const { data } = res
        if (data == '05') {
          this.videoMust = true
          this.imageMust = true
        } else if (data == '06') {
          this.videoMust = true
          this.imageMust = false
        } else if (data == '07') {
          this.videoMust = false
          this.imageMust = true
        } else if (data == '08') {
          this.videoMust = false
          this.imageMust = false
        }
      }).finally(() => {
      })

      this.row = row
      this.type = type
      this.formData = {
        arguePrice: '',
        arguePriceChx: '',
        argueNote: '',
        images: []
      }

      // this.$refs['uploadImgOrVideo']?.init()
      this.getArgueDetail()
      this.$nextTick(() => {
        this.$refs['formRef']?.clearValidate()
        this.visible = true
      })
    },
    getArgueDetail() {
      this.loading = true
      const { argueNo, subArgueNo, chxChannelCode } = this.row
      this.chxChannelCode = chxChannelCode
      http.detail({
        argueNo: argueNo == '--' ? undefined : argueNo,
        subArgueNo: subArgueNo == '--' ? undefined : subArgueNo
      }).then(res => {
        this.info = res.data
        const { argueNote, images, items, applyNote, arguePrice, chxState, arguePriceChx,
          auditNote, orderNo, voucherApplyList,
          voucherList, voucherActualList, tracingActualList, tracingList, amount, applyNum, chxChannelCode } = res.data
        this.chxChannelCode = chxChannelCode
        this.addCatalog()

        console.log(this.type, "测试bug");
        // if (this.type === 'create') {
        //   this.formData.images = images
        //   this.formData.arguePrice = arguePrice
        //   this.formData.argueNote = [...(items || []), applyNote].filter(v => v).join('，')
        // }
        if (this.type === 'anewcreate') {

          console.log('argueNote', argueNote);

          this.formData.orderNo = orderNo
          this.formData.subArgueNo = subArgueNo
          this.formData.arguePrice = arguePrice
          this.formData.arguePriceChx = arguePriceChx
          this.formData.applyNum = applyNum
          this.formData.argueNote = argueNote ? argueNote : ''
          // this.formData.argueNote = [...(items || []), applyNote].filter(v => v).join('，')

          // this.checkList = tracingList ? tracingList?.map(le => le.tracingName) : []
          this.formData.images = voucherApplyList?.filter(item => item.mediaType === "00").map(item => item.url);
          this.videos = voucherApplyList?.filter(item => item.mediaType === "01").map(item => item.url);


        }
        if (this.type === 'detail') {
          this.checkList = tracingList ? tracingList?.map(le => le.tracingName) : []
          this.videos = voucherList?.filter(item => item.mediaType === "01").map(item => item.url);
          this.formData = {
            orderNo, subArgueNo, arguePrice, applyNum,

            arguePriceChx, argueNote, images: voucherList?.filter(item => item.mediaType === "00").map(item => item.url),
            chxState, amount, itemsString: tracingActualList ? tracingActualList?.map(le => le.tracingName).join(', ') : '--',
            auditNote, voucherActualImages: voucherActualList?.map(le => le.url),

          }
        }
      }).finally(() => {
        this.loading = false
      })
    },

    close() {
      this.visible = false
      this.clickShow = '01'
      this.catalogAllList = []
      this.catalogList = []
      this.checkList = []
      // if (this.row.comeplat) {
      //   window.location.href = `/difference/platformReview`;
      // }

    },
    clickChange(val) {
      this.clickShow = val
    },
    addCatalog() {
      if (this.chxChannelCode) {
        http.chxDownList({ channelCode: this.chxChannelCode }).then((res) => {

          const _res = res.data?.map((le) => {
            return {
              id: le.key,
              name: le.value,
            }
          })
          let { tracingList } = this.info
          let tra = tracingList?.map((le) => {
            return {
              id: le.tracingId,
              name: le.tracingName,
            }
          })
          if (tracingList && tracingList[0]) {
            this.checkList = tra ? tra?.map(le => le.name) : []
            this.catalogAllList = _res.concat(tra)
            this.catalogList = _res.concat(tra)
            const uniqueArr = this.catalogAllList.filter(
              (item, index) =>
                this.catalogAllList.findIndex((i) => i.id === item.id) === index
            );
            this.catalogAllList = uniqueArr;
            const uniqueArr1 = this.catalogList.filter(
              (item, index) =>
                this.catalogList.findIndex((i) => i.id === item.id) === index
            );
            this.catalogList = uniqueArr1;
          } else {
            this.catalogAllList = _res
            this.catalogList = _res
          }



          console.log(this.checkList, ' this.checkList');

        })
      }
      // else {
      //   http.down().then((res) => {
      //     this.catalogAllList = res.data
      //     this.catalogList = res.data
      //   })
      // }

    },
    blurInput(val) {
      console.log('catalogAllList', this.catalogAllList);
      console.log(this.catalogInput, 'catalogInput');
      if (this.catalogAllList == '') {
        this.catalogList = this.catalogAllList
      } else {
        this.catalogList = this.fuzzySearchCatalogs(this.catalogAllList, this.catalogInput)
      }
    },
    fuzzySearchCatalogs(data, searchTerm) {
      if (!searchTerm) return data; // 如果搜索词为空，返回全部数据

      const lowerSearchTerm = searchTerm.toLowerCase();

      return data.filter(item =>
        item.name.toLowerCase().includes(lowerSearchTerm)
      );
    },
    handleTagClose(tag) {
      // 从checkList中移除关闭的tag
      this.checkList = this.checkList.filter(item => item !== tag);
    },
    optionsFilter(v, options) {
      return options.find((item) => item.value == v)?.label;
    },
    getIdsByCatalogNames(data, catalogNames) {
      return data
        .filter(item => catalogNames.includes(item.name))
        .map(item => item.id);
    },
    confirm() {
      const imgsAndVids = [
        ...this.formData.images,
        ...this.videos,
      ]
      // console.log({
      //   ...this.formData,
      //   argueNo: this.row.argueNo,
      //   tracingIdList: this.getIdsByCatalogNames(this.catalogAllList, this.checkList)
      // }, 'formRef', this.checkList);
      this.$refs['formRef'].validate((vaild) => {
        if (vaild) {
          const { arguePriceChx } = this.formData
          http.apply({
            ...this.formData,
            arguePrice: arguePriceChx,
            arguePriceChx: null,
            images: null,
            voucherList: imgsAndVids?.map(le => {
              return {
                mediaType: le.slice(-3) == 'mp4' ? '01' : '00',
                url: le
              }
            }),
            argueNo: this.row.argueNo,
            tracingIdList: this.getIdsByCatalogNames(this.catalogAllList, this.checkList)
          }).then(() => {
            this.$message.success('操作成功')
            this.close()
            this.$emit('confirm')
          })
          console.log('ccc', {
            ...this.formData,
            arguePrice: arguePriceChx,
            arguePriceChx: null,
            images: null,
            voucherList: imgsAndVids?.map(le => {
              return {
                mediaType: le.slice(-3) == 'mp4' ? '01' : '00',
                url: le
              }
            }),
            argueNo: this.row.argueNo,
            tracingIdList: this.getIdsByCatalogNames(this.catalogAllList, this.checkList)
          });

        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.button_top {
  cursor: pointer;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.faultBtn {
  width: 300px;
  height: 42px;
  background: #f9fbfd;
  border: 1px solid #c1d1ff;
  box-shadow: 0px 4px 8px 0px rgba(196, 197, 198, 0.2);
  border-radius: 21px;
  display: flex;

  .active {
    text-align: center;
    color: white;
    width: 50%;
    height: 40px;
    font-size: 14px;
    font-family: FZLanTingHei-M-GBK;
    font-weight: 400;
    line-height: 40px;
    background: #0981ff;
    border-radius: 20px;
  }

  .none {
    text-align: center;
    color: #333;
    width: 50%;
    height: 40px;
    font-size: 14px;
    font-family: FZLanTingHei-M-GBK;
    font-weight: 400;
    line-height: 40px;
    border-radius: 20px;
  }
}

.box {
  padding: 10px;

  &.gray {
    background: rgb(245, 246, 250);
  }
}

.title {
  font-weight: bold;
  margin-bottom: 10px;
}

.info-item {
  margin-bottom: 8px;
  display: flex;
}

.mr-30 {
  margin-right: 30px;
}

.ml-10 {
  margin-left: 10px;
}
</style>
